import { GameConfig } from '@/types/lottery/config'
import { useMemo } from 'react'

export function calculateMaxRoundsInPot(gameConfig: GameConfig) {
    if (gameConfig.chanceInitialAmount === 0) {
        return null
    }

    let chance = BigInt(gameConfig.chanceInitialAmount)
    let maxRoundsInPot = 1
    while (chance < gameConfig.maxProbability && maxRoundsInPot <= 9999) {
        chance = (chance * BigInt(gameConfig.chanceMultiplierAmount)) / 100n
        chance += BigInt(gameConfig.chanceIncrementAmount)
        maxRoundsInPot++
    }
    return maxRoundsInPot
}

export default function useMaxRoundsInPot(gameConfig: GameConfig) {
    return useMemo(() => {
        return calculateMaxRoundsInPot(gameConfig)
    }, [gameConfig])
}